import React from 'react'
import { getCuitInformationAction } from '../../../actions/appActions'
import Loader from '../../loaders'
import { strings } from '../../../localization/strings'
import { TextField } from '@material-ui/core/index'
import Button from '@material-ui/core/Button'
import IconButton from '@material-ui/core/IconButton'
import SearchIcon from '@material-ui/icons/SearchOutlined'
import ClearIcon from '@material-ui/icons/ClearOutlined'
import { CuitNumberFormat } from '../../../utils/formaters'
import { getErrorType } from '../../../utils/exceptions'
import { mailRegExp } from '../../../utils/regex'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import Checkbox from '@material-ui/core/Checkbox'

class Component extends React.Component {
    initialState = {
        loader: false,
        editing: false,
        cuitTmp: '',
        cuit: '',
        businessName: '',
        taxingCategoryId: '',
        isValidated: false,
        contactMailBilling: '',
        contactMailBillingError: false,
    }

    state = {
        ...this.initialState,
        ...this.props.initialValue,
        contactMailCheck: true,
    }

    clearCuit = () => {
        this.setState({
            cuit: '',
            businessName: '',
            taxingCategoryId: '',
            isValidated: false,
            cuitTmp: '',
        })
    }

    validateCuit = (closeWhenDone) => {
        if (!this.state.cuitTmp) return
        this.setState({ loader: true })
        getCuitInformationAction(this.state.cuitTmp)
            .then((billingInformation) => {
                if (!closeWhenDone) {
                    this.setState({
                        ...billingInformation,
                        cuitTmp: billingInformation.cuit,
                    })
                } else {
                    this.updateStateAndClose(billingInformation)
                }
            })
            .catch((error) => {
                let billingInformation = {
                    cuit: this.state.cuitTmp,
                    businessName: this.initialState.businessName,
                    taxingCategoryId: this.initialState.taxingCategoryId,
                    isValidated: this.initialState.isValidated,
                }
                let errorType = getErrorType(error)
                if (
                    errorType === 'TaxingCategoryNotValidException' ||
                    errorType === 'IdentificationInactiveException' ||
                    errorType === 'IdentificationTypeNotValidException' ||
                    errorType === 'BillingInformationInvalidFormatException'
                ) {
                    window.showDialog(error)
                } else {
                    if (!closeWhenDone) {
                        this.setState(billingInformation)
                    } else {
                        this.updateStateAndClose(billingInformation)
                    }
                }
            })
            .finally(() => {
                this.setState({ loader: false })
            })
    }

    render() {
        if (this.state.loader) return <Loader />
        const { canOpen } = this.props
        const { editing, cuitTmp } = this.state
        const { taxingCategoryList } = this.props
        const {
            businessName,
            cuit,
            taxingCategoryId,
            isValidated,
            contactMailBilling,
            contactMailBillingError,
        } = this.state
        const formatReq = (string) => (
            <div>
                {string}
                <span style={{ color: 'red' }}> *</span>
            </div>
        )

        var taxingCategoryName = taxingCategoryList.find(
            (x) => x.id === taxingCategoryId
        )
        taxingCategoryName = taxingCategoryName ? taxingCategoryName.name : ''

        return (
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    margin: '50px 0px',
                }}
            >
                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'baseline',
                        margin: '20px auto 10px auto',
                    }}
                >
                    {strings.billingInformation_title}
                    <Button
                        color="primary"
                        size="small"
                        onClick={this.onEditClick}
                        disabled={!canOpen}
                    >
                        {strings.registrationAddressUpdateButton}
                    </Button>
                </div>

                {!editing ? (
                    !cuit ? (
                        <div
                            style={{
                                color: 'red',
                                fontSize: '80%',
                                margin: 'auto',
                            }}
                        >
                            Faltan completar datos obligatorios
                        </div>
                    ) : (
                        <div
                            style={{
                                display: 'flex',
                                flexDirection: 'column',
                                flexWrap: 'wrap',
                                justifyContent: 'space-between',
                                marginTop: 10,
                            }}
                        >
                            {!taxingCategoryName || !businessName ? (
                                <>
                                    <div
                                        style={{
                                            color: 'rgb(97, 26, 21)',
                                            backgroundColor:
                                                'rgb(253, 236, 234)',
                                            flexGrow: 1,
                                            fontSize: '75%',
                                            textAlign: 'center',
                                        }}
                                    >
                                        {
                                            strings.billingInformation_failValidation
                                        }
                                    </div>
                                    <span
                                        style={{
                                            fontSize: '80%',
                                            padding: '10px 5px',
                                        }}
                                    >
                                        {strings.billingInformation_cuit}:{' '}
                                        {cuit}
                                    </span>
                                </>
                            ) : (
                                <>
                                    <span
                                        style={{
                                            fontSize: '80%',
                                            padding: '10px 5px',
                                        }}
                                    >
                                        {strings.billingInformation_cuit}:{' '}
                                        {cuit}
                                    </span>
                                    <span
                                        style={{
                                            fontSize: '80%',
                                            padding: '10px 5px',
                                        }}
                                    >
                                        {
                                            strings.billingInformation_taxingCategory
                                        }
                                        : {taxingCategoryName}{' '}
                                    </span>
                                    <span
                                        style={{
                                            fontSize: '80%',
                                            padding: '10px 5px',
                                            width: '100%',
                                        }}
                                    >
                                        {
                                            strings.billingInformation_businessName
                                        }
                                        : {businessName}{' '}
                                    </span>
                                </>
                            )}
                            {!contactMailBilling ? null : (
                                <span
                                    style={{
                                        fontSize: '80%',
                                        padding: '10px 5px',
                                        width: '100%',
                                    }}
                                >
                                    {strings.billingInformation_contactMail}:{' '}
                                    {contactMailBilling}{' '}
                                </span>
                            )}
                        </div>
                    )
                ) : (
                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            marginTop: 10,
                        }}
                    >
                        <div
                            style={{
                                display: 'flex',
                                flexDirection: 'row',
                                justifyContent: 'space-between',
                                alignItems: 'baseline',
                            }}
                        >
                            <TextField
                                style={{ marginTop: 20, maxWidth: 150 }}
                                InputLabelProps={{ shrink: true }}
                                fullWidth
                                InputProps={{
                                    inputComponent: CuitNumberFormat,
                                    readOnly: isValidated,
                                }}
                                label={formatReq(
                                    strings.billingInformation_cuit
                                )}
                                placeholder={
                                    strings.billingInformation_cuitPlaceholder
                                }
                                value={cuitTmp}
                                onChange={(e) =>
                                    this.setState({ cuitTmp: e.target.value })
                                }
                            />
                            {!isValidated ? (
                                <IconButton
                                    color="primary"
                                    aria-label="upload picture"
                                    component="span"
                                    onClick={() => this.validateCuit(false)}
                                >
                                    <SearchIcon />
                                </IconButton>
                            ) : (
                                <IconButton
                                    color="primary"
                                    aria-label="upload picture"
                                    component="span"
                                    onClick={this.clearCuit}
                                >
                                    <ClearIcon />
                                </IconButton>
                            )}
                            {cuit && !isValidated ? (
                                <div
                                    style={{
                                        color: 'rgb(97, 26, 21)',
                                        backgroundColor: 'rgb(253, 236, 234)',
                                        flexGrow: 1,
                                        fontSize: '75%',
                                        textAlign: 'center',
                                    }}
                                >
                                    {strings.billingInformation_failValidation}
                                </div>
                            ) : (
                                <div style={{ flexGrow: 1 }} />
                            )}
                        </div>

                        {!isValidated ? null : (
                            <>
                                <TextField
                                    style={{ marginTop: 20 }}
                                    InputLabelProps={{ shrink: true }}
                                    fullWidth
                                    InputProps={{ readOnly: true }}
                                    label={
                                        strings.billingInformation_businessName
                                    }
                                    variant="filled"
                                    value={businessName}
                                />
                                <TextField
                                    style={{ marginTop: 20 }}
                                    InputLabelProps={{ shrink: true }}
                                    fullWidth
                                    InputProps={{ readOnly: true }}
                                    label={
                                        strings.billingInformation_taxingCategory
                                    }
                                    variant="filled"
                                    value={taxingCategoryName}
                                />
                            </>
                        )}

                        <TextField
                            style={{ marginTop: 20 }}
                            label={formatReq(
                                strings.billingInformation_contactMail
                            )}
                            placeholder={
                                strings.billingInformation_contactMailPlaceholder
                            }
                            value={contactMailBilling}
                            onChange={(e) =>
                                this.setState({
                                    contactMailBilling: e.target.value,
                                })
                            }
                            error={contactMailBillingError}
                            InputLabelProps={{ shrink: true }}
                            fullWidth
                            InputProps={{
                                readOnly: this.state.contactMailCheck,
                            }}
                        />

                        <FormControlLabel
                            style={{ marginTop: 'auto', fontSize: '65%' }}
                            control={
                                <Checkbox
                                    checked={this.state.contactMailCheck}
                                    onChange={() =>
                                        this.updateCheck(
                                            !this.state.contactMailCheck
                                        )
                                    }
                                />
                            }
                            label={strings.billingInformation_contactMailCheck}
                        />

                        {!contactMailBillingError ? null : (
                            <ul
                                style={{
                                    color: 'red',
                                    fontSize: 14,
                                    paddingLeft: '1em',
                                    fontStyle: 'italic',
                                }}
                            >
                                <li>{strings.mailHint}</li>
                            </ul>
                        )}

                        <div
                            style={{
                                display: 'flex',
                                flexDirection: 'row',
                                justifyContent: 'space-between',
                                marginTop: 20,
                            }}
                        >
                            <div style={{ flexGrow: 1 }} />
                            <Button
                                color="primary"
                                variant="contained"
                                size="small"
                                onClick={this.submitCancel}
                            >
                                {strings.dialogCancelLabel}
                            </Button>
                            <div style={{ width: 100 }} />
                            <Button
                                color="primary"
                                variant="contained"
                                size="small"
                                onClick={this.submitOk}
                            >
                                {strings.dialogOkLabel}
                            </Button>
                        </div>
                    </div>
                )}
            </div>
        )
    }

    submitOkData = () => {
        let {
            businessName,
            cuit,
            taxingCategoryId,
            isValidated,
            contactMailBilling,
        } = { ...this.state }
        return {
            businessName,
            cuit,
            taxingCategoryId,
            isValidated,
            contactMailBilling,
        }
    }

    submitOk = () => {
        if (
            this.state.isValidated === false &&
            this.state.cuitTmp !== this.state.cuit
        ) {
            this.validateCuit(true)
        } else {
            let data = this.submitOkData()
            if (!data) return
            this.updateStateAndClose(data)
        }
    }

    updateStateAndClose = (data) => {
        data.contactMailBilling = this.state.contactMailBilling
        if (
            !data.contactMailBilling ||
            !mailRegExp.test(data.contactMailBilling)
        ) {
            this.setState({ contactMailBillingError: true })
            return
        }
        this.props.onChange(data)
        this.props.toggleOpen(false)
        this.clearState(data)
    }

    submitCancel = () => {
        this.props.toggleOpen(false)
        this.clearState(this.props.initialValue)
    }

    onEditClick = () => {
        this.setState({ editing: true, cuitTmp: this.state.cuit })
        this.props.toggleOpen(true)
    }

    clearState = (data) => {
        this.setState({ ...this.initialState, ...data })
    }

    componentDidUpdate(prevProps) {
        if (this.props.userMail !== prevProps.userMail) {
            this.updateCheck(this.state.contactMailCheck)
        }
    }

    updateCheck = (check) => {
        if (check)
            this.setState({
                contactMailBilling: this.props.userMail,
                contactMailCheck: check,
            })
        else
            this.setState({
                contactMailCheck: check,
            })
    }
}

export default Component
